import { apiSlice } from "../../app/api/apiSlice";

export const criterionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchCarePrograms: builder.mutation({
      query: () => ({
        url: "/criterion/care-programs",
        method: "GET",
      }),
    }),
    createCareProgram: builder.mutation({
      query: (body) => ({
        url: "/criterion/care-programs",
        method: "POST",
        body,
      }),
    }),
    updateCareProgram: builder.mutation({
      query: (body) => ({
        url: "/criterion/care-programs",
        method: "PATCH",
        body,
      }),
    }),
    deleteCareProgram: builder.mutation({
      query: (body) => ({
        url: "/criterion/care-programs",
        method: "DELETE",
        body,
      }),
    }),

    fetchRiskLevels: builder.mutation({
      query: () => ({
        url: "/criterion/risk-levels",
        method: "GET",
      }),
    }),
    updateRiskLevel: builder.mutation({
      query: (body) => ({
        url: "/criterion/risk-levels",
        method: "PATCH",
        body,
      }),
    }),

    fetchLobs: builder.mutation({
      query: () => ({
        url: "/criterion/lobs",
        method: "GET",
      }),
    }),

    fetchPayers: builder.mutation({
      query: () => ({
        url: "/criterion/payers",
        method: "GET",
      }),
    }),

    fetchAppointmentTypeCriteria: builder.mutation({
      query: () => ({
        url: "/criterion/appointment-type-criteria",
        method: "GET",
      }),
    }),
    createAppointmentTypeCriteria: builder.mutation({
      query: (body) => ({
        url: "/criterion/appointment-type-criteria",
        method: "POST",
        body,
      }),
    }),
    updateAppointmentTypeCriteria: builder.mutation({
      query: (body) => ({
        url: "/criterion/appointment-type-criteria",
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useFetchCareProgramsMutation,
  useCreateCareProgramMutation,
  useUpdateCareProgramMutation,
  useDeleteCareProgramMutation,
  useFetchRiskLevelsMutation,
  useUpdateRiskLevelMutation,
  useFetchLobsMutation,
  useFetchPayersMutation,
  useFetchAppointmentTypeCriteriaMutation,
  useCreateAppointmentTypeCriteriaMutation,
  useUpdateAppointmentTypeCriteriaMutation,
} = criterionApiSlice;
